import HomePage from 'Pages/Home/Home';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Box from '@mui/material/Box';
import './App.scss';
import { useAuth } from 'Hooks/useAuth';
import SignIn from 'Pages/SignIn/SignIn';
import Dashboard from 'Pages/Dashboard/Dashboard';
import SignUp from 'Pages/SignUp/SignUp';
import ConfirmSignUp from 'Pages/ConfirmSignUp/ConfirmSignUp';
import { LinearProgress } from '@mui/material';
import ForgotPassword from 'Pages/ForgotPassword/ForgotPassword';
import ConfirmForgotPassword from 'Pages/ConfirmForgotPassword/ConfirmForgotPassword';
import CreateRecipe from 'Pages/CreateRecipe/CreateRecipe';
import EditRecipe from 'Pages/EditRecipe/EditRecipe';
import Profile from 'Pages/Profile/Profile';
import RecipeDetail from 'Pages/RecipeDetail/RecipeDetail';
import { ROUTES } from 'Utils/routes';
import OfflineBanner from 'Components/OfflineBanner/OfflineBanner';

const App = () => {
  const auth = useAuth();

  return auth.isLoading ? (
    <Box sx={{ width: '100%' }}>
      <LinearProgress />
    </Box>
  ) : (
    <>
      <OfflineBanner />
      <BrowserRouter>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path={ROUTES.SIGN_IN} element={<SignIn />} />
          <Route path={ROUTES.SIGN_UP} element={<SignUp />} />
          <Route path={ROUTES.CONFIRM_SIGN_UP} element={<ConfirmSignUp />} />
          <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
          <Route path={ROUTES.CONFIRM_FORGOT_PASSWORD} element={<ConfirmForgotPassword />} />
          <Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
          <Route path={ROUTES.PROFILE} element={<Profile />} />
          <Route path={ROUTES.CREATE_RECIPE} element={<CreateRecipe />} />
          <Route path={ROUTES.EDIT_RECIPE} element={<EditRecipe />} />
          <Route path={ROUTES.RECIPE_DETAIL} element={<RecipeDetail />} />
          <Route path='*' element={<p>Page Not Found</p>} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
